<template>
  <div class="container scheduling">
    <div class="row">
      <div class="col-12 col-md-6">
        <h1 class="mb-45">
          Scheduling
        </h1>
      </div>
      <div class="col-12 col-md-6 text-right">
        <button
          v-b-modal.pending-modal
          class="btn btn-primary btn-wide pending-btn"
        >
          <span>Pending</span>
          <div class="count">
            7
          </div>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-8 col-xl-9">
        <div class="dashboard-card calendar-card">
          <!--TODO: Replace everything in this card with an atual calendar. I'll style once I see
            what we're actually working with-->
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="date-button-picker">
                <button class="prev">
                  <font-awesome-icon
                    :icon="['fas', 'caret-left']"
                    class="icon alt"
                  />
                </button>
                <button class="date-trigger">
                  October
                </button>
                <button class="next">
                  <font-awesome-icon
                    :icon="['fas', 'caret-right']"
                    class="icon alt"
                  />
                </button>
              </div>
            </div>
            <div class="col-12 col-md-6 text-right">
              <b-button-group>
                <b-button class="active">
                  Month
                </b-button>
                <b-button>Week</b-button>
              </b-button-group>
            </div>
          </div>
          <img
            src="@/assets/img/temp-calendar.png"
            alt="Calendar"
          >
        </div>
      </div>
      <div class="col-12 col-lg-4 col-xl-3">
        <div class="dashboard-card">
          <h4 class="mb-30">
            Availability
          </h4>
          <table class="table bm-table">
            <tr>
              <td>
                Mon
              </td>
              <td class="text-right">
                9AM - 5PM
              </td>
            </tr>
            <tr>
              <td>
                Tue
              </td>
              <td class="text-right">
                9AM - 5PM
              </td>
            </tr>
            <tr>
              <td>
                Wed
              </td>
              <td class="text-right">
                9:30AM - 5:30PM
              </td>
            </tr>
            <tr>
              <td>
                Thu
              </td>
              <td class="text-right">
                9AM - 5PM
              </td>
            </tr>
            <tr>
              <td>
                Fri
              </td>
              <td class="text-right">
                9AM - 5PM
              </td>
            </tr>
          </table>
          <h4 class="mb-30 mt-4">
            Calendars
          </h4>
          <table class="table bm-table">
            <tr>
              <td>
                Google Cal
              </td>
              <td class="text-right">
                <font-awesome-icon
                  :icon="['fas', 'check-circle']"
                  class="icon alt"
                />
              </td>
            </tr>
            <tr>
              <td>
                iCal
              </td>
              <td class="text-right">
                <font-awesome-icon
                  :icon="['fas', 'check-circle']"
                  class="icon alt"
                />
              </td>
            </tr>
          </table>
          <button
            v-b-modal.availability-modal
            class="btn btn-primary"
            style="width: 100%;"
          >
            Edit
          </button>
        </div>
      </div>
    </div>
    <!--Pending Modal-->
    <pending-modal />
    <!--Availability Modal-->
    <availability-modal />
  </div>
</template>

<script>
import pendingModal from '@/components/modals/PendingModal.vue';
import availabilityModal from '@/components/modals/AvailabilityModal.vue';

export default {
  name: 'Scheduling',
  components: {
    pendingModal,
    availabilityModal,
  },
  data: () => ({
  }),
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.scheduling {
  .pending-btn {
    white-space: nowrap;
    margin-bottom: 15px;

    @media (min-width: $md-min) {
      margin-top: 7px;
    }

    span,
    .count {
      display: inline-block;
      vertical-align: top;
    }

    .count {
      @include border-radius(200px);

      background: #132940;
      color: $green;
      margin-left: 10px;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 15px;
      line-height: 24px;
      height: 24px;
    }
  }

  ::v-deep .btn-group {
    margin-top: 8px;

    @media (max-width: $sm-max) {
      width: 100%;
    }

    .btn {
      @include border-radius($border-radius !important);

      background: rgba(255, 255, 255, 0.25) !important;
      color: white !important;
      margin-right: 5px;
      font-weight: normal;

      @media (min-width: $xl-min) {
        min-width: 120px;
      }

      &.last {
        margin-right: 0;
      }

      &.active {
        background-color: $green !important;
        color: $dark-blue !important;
      }

      @media (max-width: $sm-max) {
        width: 25%;
      }
    }
  }

  .date-button-picker {
    margin-bottom: 30px;
    margin-top: 5px;

    .prev,
    .next,
    .date-trigger {
      border: none;
      background: none;
      height: 45px;
      width: 45px;
      font-size: 30px;
      display: inline-block;
      vertical-align: top;

      i,
      svg {
        color: $green;
      }
    }

    .prev {
      padding-left: 0;
      text-align: left;
    }

    .next {
      padding-right: 0;
      text-align: right;
    }

    .date-trigger {
      width: auto;
      color: white;
      font-size: 18px;
      font-weight: bold;
      line-height: 46px;
      padding-top: 0;
      padding-bottom: 0;

      @media (max-width: $sm-max) {
        width: calc(100% - 90px);
      }
    }
  }

  .calendar-card {
    img {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
    }
  }
}
</style>
